@if (product$ | async; as product) {
  <div class="container" [innerHTML]="product?.description"></div>
  @if (product?.certificationLogos && product?.certificationLogos.length > 0) {
    <div>
      <section class="certificationLogos">
        @for (certificationLogo of product.certificationLogos; track certificationLogo) {
          <img
            class="certificationLogos__image"
            [src]="getCertificationLogo(certificationLogo.url)"
            />
        }
      </section>
    </div>
  }
}
